import {useEffect, useState, useRef} from 'react'
import PageApp from '../../../Page';
import ModalEdit from './Edit'
import { HomeOutlined, UnorderedListOutlined, ClockCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import {Table, Empty, Modal, Divider, Button, message, Space, Tag} from 'antd';
import {getAll, drop} from '../../../../apis/VariablesFormulaApi';
import _ from 'lodash'

const { confirm } = Modal;

const routes = [  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Catálogos</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Variables de Formulas</span>
      </>
    ),
}];

const VariableFormulaPage = () => {
    const [items, setItems] = useState([]);
    const [openEdit, setOpenEdit] = useState(false);
    const [objectSelected, setobjectSelected] = useState(null);
    const [loading, setLoading] = useState(true);
    
    const columns = [
      {
        title: 'Nombre',
        dataIndex: 'nombre',
        key: 'nombre',
      },
      {
        title: 'Descripcion',
        dataIndex: 'descripcion',
        key: 'descripcion',
      },
      {
        title: 'Tipo de dato',
        dataIndex: 'tipo_dato',
        key: 'tipo_dato',
        render: (item, object)=> {
          console.log(item)
          switch(item?.toString()){
            case '1':
              return  <Tag color="green">Numerico</Tag>;
            case '2':
              return  <Tag color="blue">Alfanumerico</Tag>;
            case '3':
              return  <Tag color="gray">Logico</Tag>;
            case '4':
              return  <Tag color="red">Fecha</Tag>;
          }
        }
      },
      {
        title: 'Clase',
        dataIndex: 'clase',
        key: 'clase',
        render: (item, object)=> {
          if(item == true){
            return  <Tag color="green">Sistema</Tag>;
          }else{
              return  <Tag color="blue">Usuario</Tag>;
          }
        }
      },
      {
        title: '',
        dataIndex: 'actions',
        key: 'actions',
        render: (item, object)=> {
          return <Space>
          <Button type='primary' size='small' onClick={()=>{
              openDetails(object);
          }}>Editar</Button>
          <Button type='primary' size='small' danger onClick={()=>{
              deleteConfirm(object);
          }}>Eliminar</Button>
        </Space>
        }
      }
    ];

    const openDetails = async (object)=>{
      setOpenEdit(true);
      setobjectSelected(object);
    }

    const deleteConfirm = async (item) => {
        confirm({
            title: '¿Confirmas en eliminar la variable?',
            icon: <ExclamationCircleFilled />,
            content: 'No podrás recuperar su información',
            onOk: ()=>{deleteOk(item.id)},
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const deleteOk = async (id)=>{
        const response = await drop(id);
        if(response.ok){
            message.success('¡La variable ha sido eliminada!');
        }
        await refreshData();
    }

    const btnClick = ()=>{
      setOpenEdit(true);
      setobjectSelected(null);
    }

    const onHandlerFinish = async (refresh) => {
      setOpenEdit(false);
      if(refresh){
        await refreshData();
      }
    }

    const refreshData = async ()=> {
      const response = await getAll();
      if(response.ok){
        let items = response.payload;
        setItems(items);
      }

      setLoading(false);
    }

    const effectRan = useRef(false);
    useEffect(() => {

      if (!effectRan.current) {
        (async () => {
          await refreshData();
        })();
      }
    
      return () => effectRan.current = true;
    }, []);
    
    return <PageApp routes={routes}>
      <Button type="primary" onClick={btnClick}>
          Agregar Variable
      </Button>
      <Divider/>
      {
          loading ? (
            <p>Loading...</p>
          ) : <>
            {
              items.length == 0 ? <Empty />:
              <Table dataSource={items} columns={columns} />
            }
          </>
      }
      {
        (openEdit && objectSelected && objectSelected.id > 0) &&
        <ModalEdit title={"Editar Variable"} id={objectSelected.id} open={openEdit} finish={onHandlerFinish}/>
      }
      {
        (openEdit && !objectSelected) &&
        <ModalEdit title={"Crear Variable"} open={openEdit} finish={onHandlerFinish}/>
      }
    </PageApp>
}   

export default VariableFormulaPage;
